

<nalco-divider *ngIf="items?.length > 0" [color]="dividerCss.color" [length]="dividerCss.minLength"
  [isHorizontal]=dividerCss.isHorizontal></nalco-divider>
<ul *ngIf="items?.length > 0" class="search-result-list" [ngClass]="{'set-height' : setHeight}">
  <div class="results-heading margin-heading">
  {{ heading | translate }} <span class="length-chip" *ngIf="items.length > 0 && displayResultCount">{{items.length}}</span>
  </div>
  <div>
    <li *ngFor="let item of items; trackBy: trackByIndex; let i = index" [class.selected]="item === selectedItem" (click)="onItemSelect(item)">
      <span class="list-icon">
        <img [src]="listIconPath" alt="Search Icon" [class]="iconClass" />
      </span> 
      <label class="checkbox-container" *ngIf="enableMultiSelect" [attr.for]="'checkbox-' + i">
        <input 
          type="checkbox" 
          [id]="'checkbox-' + i"
          [checked]="item.selected || false"
          (change)="onCheckboxChange(item, $event)"
          class="item-checkbox" />
        <span class="checkbox-custom"></span>
      </label>
      <div >
        <div [ngClass]="((item.primaryText?.length) > 90 || (displaySecondaryText && item.secondaryText)) ? 'no-margin-top' : 'margin-top-7'"
          [innerHTML]="item.primaryText | highlightText : searchInput : 'primaryTextMark'"></div>
        <div class="secondaryTextSet" *ngIf="displaySecondaryText">
          <div class="secondary-text">
            <span [innerHTML]="item.secondaryText | highlightText : searchInput : 'secondaryTextMark'"></span>
          </div>
        </div>
      </div>
      <span class="id-chip" *ngIf="item.filterName">
        <h6>{{item.filterName}}</h6>
      </span>
    </li>
  </div>
</ul>